// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__COp9C","stars":"Rating_stars__TTvZn","star":"Rating_star__HKG5W","number":"Rating_number__scqqp"};